import { Component, Input } from '@angular/core';
import { Riskanalysis } from 'src/app/kuba/follow-ups/models/riskanalysis';

/**
 * Portal dashboard risk analysis card (#5672).
 *
 * Replaced the per-business summary table with a single speedometer gauge whose
 * needle sits on the median risk figure across all records.
 */
@Component({
  selector: 'app-risk-analysis-portal-widget',
  templateUrl: './risk-analysis-portal-widget.component.html',
  styleUrls: ['./risk-analysis-portal-widget.component.css'],
  standalone: false
})
export class RiskAnalysisAdminAndPortalWidgetComponent {
  @Input() riskAnalysis: Riskanalysis[] = [];
}
